import { render, staticRenderFns } from "./vzmaterial.vue?vue&type=template&id=a6ed4c20&"
import script from "./vzmaterial.vue?vue&type=script&lang=js&"
export * from "./vzmaterial.vue?vue&type=script&lang=js&"
import style0 from "./vzmaterial.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/workspace/yx-web-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a6ed4c20')) {
      api.createRecord('a6ed4c20', component.options)
    } else {
      api.reload('a6ed4c20', component.options)
    }
    module.hot.accept("./vzmaterial.vue?vue&type=template&id=a6ed4c20&", function () {
      api.rerender('a6ed4c20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Homelive/components/vzmaterial.vue"
export default component.exports